// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kD37","content":"styles_content__3Godt"};